document.querySelectorAll(".js-media-zoom").forEach(el => {
  el.addEventListener('click', function (e) {
    const index = e.currentTarget.dataset.index ?? document.querySelector('.js-product-media-main').current
    
    el.dispatchEvent(
      new CustomEvent('openDrawer', {
        bubbles: true,
        composed: true,
        detail: {
          key: 'media-zoom',
          event: e,
          index: index,
        },
      })
    )
  })
})
